import React from 'react';
import { ReactourStep } from 'reactour';
import TemplateImage from '@assets/images/tour/template.png';
import UploadFileImage from '@assets/images/tour/upload-file.png';
import DragDropFileImage from '@assets/images/tour/drag-drop-file.png';
import FirstProjectImage from '@assets/images/tour/first-project.png';
import ToolBarImage from '@assets/images/tour/tool-bar.png';
import CommentsImage from '@assets/images/tour/comments.png';
import ViewAnnotationsImage from '@assets/images/tour/view-annotations.png';
import UploadLatestImage from '@assets/images/tour/upload-latest.png';
import CommentPinsImage from '@assets/images/tour/comment-pins.png';
import ViewVersionsImage from '@assets/images/tour/view-versions.png';
import MakeDecisionImage from '@assets/images/tour/make-decision.png';
import TurnCommentIntoTaskImage from '@assets/images/tour/turn-comment-into-task.png';
import TourPausedReviewAssetImage from '@assets/images/tour/tour-paused-review-asset.png';
import SpecificTaskDetailsImage from '@assets/images/tour/specific-task-details.png';
import AddContextImage from '@assets/images/tour/add-context.png';
import DocumentNavigationImage from '@assets/images/tour/document-navigation.png';
import TextHighlightImage from '@assets/images/tour/text-highlight.png';
import CopyEditedTextImage from '@assets/images/tour/copy-edited-text.png';
import TimestampedFeedbackImage from '@assets/images/tour/timestamped-feedback.png';
import TimeRangeFeedbackImage from '@assets/images/tour/time-range-feedback.png';
import CopyCommentsImage from '@assets/images/tour/announcement-media-viewer-copy-comment.png';
import CompareVersionsImage from '@assets/images/tour/announcement-media-viewer-compare.png';
import MediaCarouselImage from '@assets/images/tour/announcement-media-viewer-carousel.png';
import BottomPanelImage from '@assets/images/tour/announcement-media-viewer-panel.png';

export const tourExitContent = {
  content: () => (
    <div className="app-tour-assist-wrapper">
      <div className="app-tour-assist-wrapper__title">
        <h2>Exit the tour?</h2>
      </div>
      <div className="app-tour-assist-wrapper__description">
        <p>
          Are you sure you want to leave the
          <br /> interactive tour?
        </p>
        <p>
          You can restart it anytime from <br />
          the Bootcamp center.
        </p>
      </div>
    </div>
  )
};

export function tourPaused() {
  return [
    {
      selector: '.tour-paused',
      highlightedSelectors: ['.tour-paused-btn'],
      style: {
        marginTop: 35
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>We paused your tour</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              You can jump back anytime — just
              <br /> click Bootcamp to resume.
            </p>
          </div>
        </div>
      ),
      stepInteraction: false
    }
  ];
}

export const tourExitContentMediaViewer = {
  content: () => (
    <div className="app-tour-assist-wrapper">
      <div className="app-tour-assist-wrapper__title">
        <h2>Exit the tour?</h2>
      </div>
      <div className="app-tour-assist-wrapper__description">
        <p>
          Are you sure your want to leave
          <br /> the tour?
        </p>
      </div>
    </div>
  )
};

export function tourPausedMediaViewer() {
  return [
    {
      selector: '.tour-paused-media-viewer',
      resizeObservables: ['.tour-paused-media-viewer'],
      position: 'right',
      style: {
        marginLeft: -58,
        marginTop: 50
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Tour paused</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              You can restart the tour anytime
              <br /> from the Help menu when you log
              <br /> into StreamWork.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img
                src={TourPausedReviewAssetImage}
                alt="#"
                style={{ maxWidth: 240 }}
              />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    }
  ];
}

export function createCampaignSteps() {
  return [
    {
      selector: '.tour-create-campaign-start',
      resizeObservables: ['.tour-create-campaign-start'],
      position: 'left',
      style: {
        marginTop: -8
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Create a new project</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Set-up a designated space to house
              <br /> media. Click &quot;New Project&quot; to get
              <br /> started.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img src={FirstProjectImage} alt="#" style={{ maxWidth: 240 }} />
            </div>
          </div>
        </div>
      ),
      stepInteraction: true
    },
    {
      selector: '.tour-create-campaign-modal',
      resizeObservables: ['.tour-create-campaign-modal'],
      position: 'right',
      style: {
        marginTop: 20
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Set-up your project</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Name your project and choose who
              <br /> can access it.
            </p>
          </div>
        </div>
      ),
      stepInteraction: false
    }
  ];
}

export function uploadAssetSteps() {
  return [
    {
      selector: '.tour-upload-asset',
      resizeObservables: ['.tour-upload-asset'],
      position: 'bottom',
      style: {
        marginLeft: -54
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Upload media</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Upload nearly any file type from
              <br /> your computer, Google Drive,
              <br /> Dropbox or Box — it’s seamless.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img src={UploadFileImage} alt="#" style={{ maxWidth: 240 }} />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-upload-asset',
      resizeObservables: ['.tour-upload-asset'],
      position: 'bottom',
      style: {
        marginLeft: -54
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Drag & Drop media</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Prefer shortcuts? Just drag and
              <br /> drop your files anywhere in the
              <br /> StreamWork window to upload
              <br /> instantly.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img src={DragDropFileImage} alt="#" style={{ maxWidth: 240 }} />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    }
  ];
}

export function createTaskFromCommentSteps(): ReactourStep[] {
  return [
    {
      selector: '.tour-create-task-from-comment-checkbox',
      resizeObservables: ['.tour-create-task-from-comment-checkbox'],
      position: 'bottom',
      style: {
        marginTop: 15,
        marginLeft: -120
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Turn comment into a task</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Create a task directly as you write
              <br /> your comment.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img
                src={TurnCommentIntoTaskImage}
                alt="#"
                style={{ maxWidth: 240 }}
              />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-create-task-from-comment-menu',
      resizeObservables: ['.tour-create-task-from-comment-menu'],
      position: 'left',
      style: {
        marginTop: 75
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Convert an existing comment</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Is a comment already posted? You
              <br /> can easily turn it into a task, too.
            </p>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-create-task-from-comment-task-details',
      resizeObservables: ['.tour-create-task-from-comment-task-details'],
      position: 'left',
      style: {
        marginTop: -40
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Specific task details</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Set a due date, assign an owner,
              <br /> and choose the task priority.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img
                src={SpecificTaskDetailsImage}
                alt="#"
                style={{ maxWidth: 240 }}
              />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-create-task-from-comment-task-input-comment',
      resizeObservables: ['.tour-create-task-from-comment-task-comment'],
      highlightedSelectors: ['.tour-create-task-from-comment-task-comment'],
      position: 'right',
      style: {
        marginTop: -50
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Add context</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Include extra details so your team
              <br /> knows exactly what needs to be
              <br /> done.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img src={AddContextImage} alt="#" style={{ maxWidth: 240 }} />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-create-task-from-comment-task-name',
      resizeObservables: ['.tour-create-task-from-comment-task-name'],
      position: 'bottom',
      style: {
        marginLeft: 150
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Task title</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Update the task title to something
              <br /> clear and relevant to your team.
            </p>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-create-task-from-comment-task-description',
      resizeObservables: ['.tour-create-task-from-comment-task-description'],
      position: 'bottom',
      style: {
        marginLeft: 150
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Add description</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              The original comment stays in the
              <br /> description, so you can always refer
              <br /> back to it.
            </p>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-create-task-from-comment-tasks',
      resizeObservables: ['.tour-create-task-from-comment-tasks'],
      position: 'left',
      style: {
        marginTop: -62
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Find your task</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              View your newly created task right
              <br /> here and start tracking progress.
            </p>
          </div>
        </div>
      ),
      stepInteraction: false
    }
  ];
}

export function reviewMediaSteps(): ReactourStep[] {
  return [
    {
      selector: '.tour-review-asset-tool-bar',
      resizeObservables: ['.tour-review-asset-tool-bar'],
      position: 'left',
      style: {
        marginTop: 40,
        marginLeft: 20
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Tool bar</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Use annotation tools to draw,
              <br /> highlight, or mark areas directly on
              <br /> media.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img src={ToolBarImage} alt="#" style={{ maxWidth: 240 }} />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-review-asset-tool-bar',
      resizeObservables: ['.tour-review-asset-tool-bar'],
      position: 'left',
      style: {
        marginTop: -110,
        marginLeft: 20
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Comment pins</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Drop pins anywhere on the image to
              <br /> leave precise feedback. You can
              <br /> even link multiple pins to one
              <br /> comment.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img src={CommentPinsImage} alt="#" style={{ maxWidth: 240 }} />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-review-asset-comments',
      resizeObservables: ['.tour-review-asset-comments'],
      position: 'bottom',
      style: {
        marginLeft: 20,
        marginTop: 15
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Comments</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Leave feedback, tag teammates, or
              <br /> turn a comment into a task to keep
              <br /> reviews simple.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img src={CommentsImage} alt="#" style={{ maxWidth: 240 }} />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-review-asset-comments',
      resizeObservables: ['.tour-review-asset-comments'],
      position: 'bottom',
      style: {
        marginLeft: 20,
        marginTop: 15
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>View annotations</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Click the pencil icon to show any
              <br /> markups tied to this comment
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img
                src={ViewAnnotationsImage}
                alt="#"
                style={{ maxWidth: 240 }}
              />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-review-asset-upload',
      resizeObservables: ['.tour-review-asset-upload'],
      position: 'bottom',
      style: {
        marginLeft: -114,
        marginTop: 15
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Upload the latest</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Upload a new file to keep all
              <br /> feedback and versions organized in
              <br /> one place.
            </p>

            <div className="app-tour-assist-wrapper__image">
              <img src={UploadLatestImage} alt="#" style={{ maxWidth: 240 }} />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-review-asset-versions',
      resizeObservables: ['.tour-review-asset-versions'],
      position: 'bottom',
      style: {
        marginLeft: -98,
        marginTop: 15
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>View all versions</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Easily switch between drafts,
              <br />
              revisions and final files to see how
              <br /> the work has evolved.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img src={ViewVersionsImage} alt="#" style={{ maxWidth: 240 }} />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-review-asset-decision',
      resizeObservables: ['.tour-review-asset-decision'],
      position: 'bottom',
      style: {
        marginLeft: -60,
        marginTop: 15
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Make a decision</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              If you&apos;ve been designated as a<br /> reviewer, you can
              approve media or
              <br />
              request changes.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img src={MakeDecisionImage} alt="#" style={{ maxWidth: 240 }} />
            </div>
          </div>
        </div>
      )
    }
  ];
}

export function textHighlightSteps(): ReactourStep[] {
  return [
    {
      selector: '.tour-text-highlight-pdf-action',
      resizeObservables: ['.tour-text-highlight-pdf-action'],
      position: 'bottom',
      style: {
        marginTop: 5,
        marginLeft: 115
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Document navigation</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Click the page navigation icon to
              <br />
              browse pages.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img
                src={DocumentNavigationImage}
                alt="#"
                style={{ maxWidth: 240 }}
              />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-text-highlight-bar',
      resizeObservables: ['.tour-text-highlight-bar'],
      position: 'right',
      style: {
        marginLeft: 20,
        marginTop: -195
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Text highlight</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Highlight any text, click the &#34;T&#34; icon
              <br /> to copy it into a comment, then
              <br /> make edits directly there.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img src={TextHighlightImage} alt="#" style={{ maxWidth: 240 }} />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-text-highlight-comments',
      resizeObservables: ['.tour-text-highlight-comments'],
      position: 'bottom',
      style: {
        marginLeft: 20,
        marginTop: 15
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Copy edited text</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Once you&apos;ve submitted your text
              <br /> edits, you can copy and paste them
              <br />
              into the original file.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img
                src={CopyEditedTextImage}
                alt="#"
                style={{ maxWidth: 240 }}
              />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    }
  ];
}

export function reviewAudioVideoSteps(): ReactourStep[] {
  return [
    {
      selector: '.tour-time-range-review-audio-video',
      resizeObservables: ['.tour-time-review-audio-video'],
      position: 'bottom',
      style: {
        marginLeft: 30,
        marginTop: 15
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Timestamped feedback</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              As you type feedback, the video
              <br /> pauses and your comment is saved
              <br /> at that timecode.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img
                src={TimestampedFeedbackImage}
                alt="#"
                style={{ maxWidth: 240 }}
              />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-time-range-review-audio-video',
      resizeObservables: ['.tour-time-review-audio-video'],
      position: 'bottom',
      style: {
        marginLeft: 30,
        marginTop: 15
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Time range feedback</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Have feedback that applies to a<br /> specific time range? Select
              the start
              <br /> and end times, then save your
              <br />
              comment to tag that entire section.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img
                src={TimeRangeFeedbackImage}
                alt="#"
                style={{ maxWidth: 240 }}
              />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    }
  ];
}

export function routeForApprovalSteps({
  action
}: {
  action?: (node: any) => void;
}) {
  return [
    {
      selector: '.tour-route-for-approval-start',
      mutationObservables: ['.tour-route-for-approval-start'],
      position: 'right',
      style: {
        marginTop: 35
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Start with a Demo Project</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Here&apos;s a sample project to walk you
              <br /> through the approval flow
            </p>
          </div>
        </div>
      ),
      stepInteraction: false,
      action
    },
    {
      selector: '.tour-route-for-approval-btn',
      mutationObservables: ['.tour-route-for-approval-btn'],
      style: {
        marginTop: -32
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Create an Approval</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Start a new approval to kick off your
              <br /> review process.
            </p>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-route-for-approval-name',
      mutationObservables: ['.tour-route-for-approval-name'],
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Name your approval</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Give your approval a custom name
              <br /> or keep the default based on your
              <br /> project.
            </p>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-route-for-approval-tabs',
      mutationObservables: ['.tour-route-for-approval-tabs'],
      style: {
        marginLeft: 500
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Create templates</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Save time by creating templates for
              <br /> faster setup. For this demo, we&apos;ll
              <br /> build one from scratch.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img src={TemplateImage} alt="#" style={{ maxWidth: 240 }} />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-route-for-approval-assets',
      mutationObservables: ['.tour-route-for-approval-assets'],
      position: 'right',
      style: {
        marginTop: 100
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Add or remove media</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Choose which media to include in
              <br /> this approval — add or remove items
              <br /> as needed.
            </p>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-route-for-approval-stages',
      mutationObservables: ['.tour-route-for-approval-stages'],
      style: {
        marginTop: 170
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Set-up stages</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Define your stages with reviewers, deadlines,
              <br /> and completion settings.
            </p>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-route-for-approval-btn-member',
      mutationObservables: ['.tour-route-for-approval-btn-member'],
      style: {
        marginTop: -58
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Add reviewers</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Add anyone inside or outside your
              <br /> organization as a reviewer and
              <br /> select their permissions.
            </p>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-route-for-approval-stages',
      mutationObservables: ['.tour-route-for-approval-stages'],
      position: 'top',
      style: {
        marginLeft: 600
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Stages are ready</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Once you&apos;ve created all stages, your
              <br /> multi-stage approval workflow is
              <br /> now in place.
            </p>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-route-for-approval-settings',
      mutationObservables: ['.tour-route-for-approval-settings'],
      position: 'right',
      style: {
        marginTop: 150
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Adjust settings</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Fine-tune your approval routing with
              <br /> advanced configuration options.
            </p>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-route-for-approval-final-assets',
      mutationObservables: [
        '.tour-route-for-approval-final-assets',
        '.tour-route-for-approval-final-stages'
      ],
      highlightedSelectors: [
        '.tour-route-for-approval-final-assets',
        '.tour-route-for-approval-final-stages'
      ],
      style: {
        marginLeft: 600
      },
      position: 'top',
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Review workflow</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Review your setup to make sure
              <br /> everything looks right before
              <br /> launch.
            </p>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-route-for-approval-final-buttons',
      mutationObservables: ['.tour-route-for-approval-final-buttons'],
      position: 'top',
      style: {
        marginLeft: 180
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Launch approval</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Once live, StreamWork
              <br /> automatically emails reviewers a<br /> link to leave
              feedback and decisions.
            </p>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-route-for-approval-campaign',
      mutationObservables: ['.tour-route-for-approval-campaign'],
      resizeObservables: ['.tour-route-for-approval-campaign'],
      position: 'bottom',
      style: {
        marginLeft: 470
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Track approval status</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Monitor progress in real-time from
              <br /> your approval dashboard.
            </p>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-route-for-approval-campaign',
      mutationObservables: ['.tour-route-for-approval-campaign'],
      resizeObservables: ['.tour-route-for-approval-campaign'],
      position: 'bottom',
      style: {
        marginLeft: 470
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>See approval details</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Click anywhere in the row to open
              <br /> the approval tray and view each
              <br /> reviewer&apos;s feedback, status, and
              <br /> decision.
            </p>
          </div>
        </div>
      ),
      stepInteraction: false
    }
  ];
}

export function announcementMediaViewerSteps() {
  return [
    {
      selector: '.tour-announcement-media-viewer-tool-bar',
      mutationObservables: ['.tour-announcement-media-viewer-tool-bar'],
      position: 'right',
      style: {
        marginTop: -45,
        marginLeft: 65
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Review tools</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              The review toolbar has moved to the
              <br /> left and now includes keyboard
              <br /> shortcuts.
            </p>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-announcement-media-viewer-sidebar-menu',
      mutationObservables: ['.tour-announcement-media-viewer-sidebar-menu'],
      position: 'right',
      style: {
        marginTop: 24,
        marginLeft: 20
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Side panels</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Panels are open by default.
              <br />
              You can close the panel with
              <br /> keyboard shortcuts.
            </p>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    // TODO: Pin panel step — temporarily disabled
    // {
    //   selector: '.tour-announcement-media-viewer-panel-section-head-pin',
    //   mutationObservables: [
    //     '.tour-announcement-media-viewer-panel-section-head-pin'
    //   ],
    //   position: 'bottom',
    //   style: {
    //     marginTop: -24,
    //     marginLeft: 108
    //   },
    //   content: () => (
    //     <div className="app-tour-assist-wrapper">
    //       <div className="app-tour-assist-wrapper__title">
    //         <h2>Pin a panel</h2>
    //       </div>
    //       <div className="app-tour-assist-wrapper__description">
    //         <p>
    //           Pin a panel to keep it open while you
    //           <br /> review.
    //         </p>
    //       </div>
    //     </div>
    //   ),
    //   stepInteraction: false
    // },
    {
      selector: '.tour-announcement-media-viewer-panel-section-head-overlay',
      resizeObservables: [
        '.tour-announcement-media-viewer-panel-section-head-overlay'
      ],
      position: 'bottom',
      style: {
        marginLeft: 15,
        marginTop: -15
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Copy comments</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Reuse feedback from one media on
              <br /> another. Copy comments from any
              <br /> media and paste them onto another
              <br /> version or related media.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img src={CopyCommentsImage} alt="#" style={{ maxWidth: 240 }} />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-announcement-media-viewer-versions',
      mutationObservables: ['.tour-announcement-media-viewer-versions'],
      position: 'right',
      style: {
        marginTop: -138,
        marginLeft: -10
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Compare media</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Watch videos in unison, compare
              <br /> images, and leave comments on files
              <br /> side-by-side.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img
                src={CompareVersionsImage}
                alt="#"
                style={{ maxWidth: 240 }}
              />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    }
  ];
}

function getAnnouncementMobileDecisionTourPosition(): [number, number] | 'top' {
  const element = document.querySelector(
    '.tour-announcement-media-viewer-mobile-decision'
  );
  if (!element) {
    return 'top';
  }

  const { top } = element.getBoundingClientRect();

  return [
    Math.max(16, Math.round((window.innerWidth - 272) / 2)),
    Math.round(top - 168 - 16)
  ];
}

export function announcementMediaViewerMobileSteps() {
  return [
    {
      selector: '.tour-announcement-media-viewer-carousel',
      mutationObservables: ['.tour-announcement-media-viewer-carousel'],
      resizeObservables: [
        '.tour-announcement-media-viewer-carousel',
        '.tour-announcement-media-viewer-panel'
      ],
      position: 'bottom',
      style: {
        left: 'calc(50% - 136px)',
        marginTop: 20
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Media Carousel</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Quickly switch between the media
              <br /> you need to review.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img src={MediaCarouselImage} alt="#" style={{ maxWidth: 240 }} />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-announcement-media-viewer-panel',
      mutationObservables: ['.tour-announcement-media-viewer-panel'],
      resizeObservables: ['.tour-announcement-media-viewer-panel'],
      position: 'top',
      style: {
        marginTop: -24,
        left: 'calc(50% - 136px)'
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Bottom panel</h2>
          </div>
          <div className="app-tour-assist-wrapper__description">
            <p>
              Swipe up to expand the panel and
              <br /> view comments, tasks, and details in
              <br /> full size.
            </p>
            <div className="app-tour-assist-wrapper__image">
              <img src={BottomPanelImage} alt="#" style={{ maxWidth: 240 }} />
            </div>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-announcement-media-viewer-mobile-action',
      mutationObservables: ['.tour-announcement-media-viewer-mobile-action'],
      resizeObservables: ['.tour-announcement-media-viewer-mobile-action'],
      position: 'top',
      style: {
        marginTop: -20,
        left: 'calc(50% - 136px)'
      },
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Review tools</h2>
          </div>
          <div
            className="app-tour-assist-wrapper__description"
            style={{ width: 240 }}
          >
            <p>
              Your essential review tools are
              <br /> always within reach.
            </p>
          </div>
        </div>
      ),
      stepInteraction: false
    },
    {
      selector: '.tour-announcement-media-viewer-mobile-decision',
      highlightedSelectors: ['.tour-announcement-media-viewer-mobile-decision'],
      resizeObservables: ['.tour-announcement-media-viewer-mobile-decision'],
      mutationObservables: ['.tour-announcement-media-viewer-mobile-decision'],
      position: getAnnouncementMobileDecisionTourPosition(),
      content: () => (
        <div className="app-tour-assist-wrapper">
          <div className="app-tour-assist-wrapper__title">
            <h2>Select a decision</h2>
          </div>
          <div
            className="app-tour-assist-wrapper__description"
            style={{ width: 240 }}
          >
            <p>
              Quickly approve media, add
              <br /> feedback, or request changes.
            </p>
          </div>
        </div>
      ),
      stepInteraction: false
    }
    // {
    //   selector: '.tour-announcement-media-viewer-mobile-decision',
    //   mutationObservables: ['.tour-announcement-media-viewer-mobile-decision'],
    //   resizeObservables: ['.tour-announcement-media-viewer-mobile-decision'],
    //   position: 'top',
    //   style: {
    //     marginTop: -20,
    //     left: 'calc(50% - 116px)'
    //   },
    //   content: () => (
    //     <div className="app-tour-assist-wrapper">
    //       <div className="app-tour-assist-wrapper__title">
    //         <h2>Review reminder</h2>
    //       </div>
    //       <div className="app-tour-assist-wrapper__description">
    //         <p>
    //           Don&apos;t forget to select a decision
    //           <br /> after reviewing the media.
    //         </p>
    //       </div>
    //     </div>
    //   ),
    //   stepInteraction: false
    // }
  ];
}
